import PropTypes from "prop-types";

export const datePickerProps = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  status: PropTypes.oneOf(["warning", "error"]),
  defaultValue: PropTypes.object,
  size: PropTypes.oneOf(["small", "middle", "large", "max"]),
  disableFn: PropTypes.oneOf(["past", "future"]),
  disabled: PropTypes.bool,
};
